import { BUILTIN_USER_ROLES } from '@salescore/features'

import type { Me } from '../hooks/useMe'

const SNAPSHOT_SQL_EDITOR_EMAILS = new Set([
  'r.ito@salescore.jp',
  't.taniguchi@salescore.jp',
  'yokohashi@salescore.jp',
  'tabata@salescore.jp',
  's.watanabe@salescore.jp',
  's.uemura@salescore.jp',
])

/**
 * @deprecated
 */
const checkEmailPoorImplementationDontUse = (email: string): boolean => SNAPSHOT_SQL_EDITOR_EMAILS.has(email)

export const canEditSnapshotModelSql = (me: Me): boolean =>
  // eslint-disable-next-line sonarjs/deprecation
  me.myUser.role === 'admin' && checkEmailPoorImplementationDontUse(me.myIdentity.email)

export const isAdmin = (me: Me): boolean => me.myUser.role === BUILTIN_USER_ROLES.admin

export const canUpdateSnapshot = isAdmin
export const canUploadImage = isAdmin
export const canUseLlmOptimizeSql = isAdmin
// eslint-disable-next-line sonarjs/todo-tag
export const canViewAdminApp = isAdmin // TODO: 本来はIdentity.roleにすべき
export const canViewAdminCollapse = isAdmin
export const canViewCompileError = isAdmin
export const canViewDimensionFilter = isAdmin
export const canViewGoalColumn = isAdmin
export const canViewKpiPivotConfig = isAdmin
export const canViewKpiPivotRecord = isAdmin
export const canViewKpiPivotSchema = isAdmin
export const canViewQueryFilter = isAdmin
export const canViewRecordNode = isAdmin
export const canViewRecords = isAdmin
export const canViewSchema = isAdmin
export const canViewSearchSqlModal = isAdmin
export const canViewSheetConfig = isAdmin
export const canViewSheetRecord = isAdmin
export const canViewSheetSchema = isAdmin
export const canViewSnapshotSchedule = isAdmin

const isAdminOrManager = (me: Me): boolean =>
  me.myUser.role === BUILTIN_USER_ROLES.manager || me.myUser.role === BUILTIN_USER_ROLES.admin

export const canEditField = (me: Me): boolean =>
  isAdminOrManager(me) || me.organization.id !== 'ac5fb7f8-4974-4ac4-9bcb-173027f1b8c7'

export const canEditViewConfigField = isAdminOrManager

export const canEditCommitmentKpiLabel = isAdminOrManager
